<template>
  <div style="background-color: #F1F2F5;padding: 20px">
    <!-- 条件区域 -->
    <!-- <div style="background-color: #FFFFFF;padding: 20px">
      <div class="search-container">
        <input
          v-model="query.title"
          type="text"
          placeholder="搜索产品名/短剧名/公司名/文案"
          class="search-input"
        >
        <button
          class="search-button"
          @click="materialListr"
        >
          <i class="el-icon-search" />
        </button>
      </div>
      <el-form
        label-width="100px"
        style="margin-top: 20px"
      >
        <el-form-item label="已选">
          <el-tag
            v-for="item in filteredSelectData"
            :key="item.filed"
            style="margin-right: 5px"
            closable
            @close="selectDataDel(item)"
          >
            {{ item.text }}
          </el-tag>
        </el-form-item>

        <div style="margin: 10px 0">
          <el-button
            type="text"
            icon="el-icon-arrow-down"
            @click="showFilter = !showFilter"
          >
            {{ showFilter ? '收起筛选' : '展开筛选' }}
          </el-button>
        </div>

        <div v-show="showFilter">
          <el-form-item label="排序方式">
            <div>
              <el-tag
                v-for="item in slot_option"
                :key="item.value"
                style="margin-right: 20px"
                :type="slot_value === item ? 'primary' : 'info'"
                effect="plain"
                @click="checkSlot(item)"
              >
                {{ item.label }}
              </el-tag>
            </div>
          </el-form-item>

          <el-form-item label="素材类型">
            <div>
              <el-tag
                v-for="item in options"
                :key="item.value"
                style="margin-right: 20px"
                :type="material_type === item ? 'primary' : 'info'"
                effect="plain"
                @click="checkMaterialType(item)"
              >
                {{ item.label }}
              </el-tag>
            </div>
          </el-form-item>

          <el-form-item label="广告形式">
            <div>
              <el-tag
                v-for="item in options2"
                :key="item.ad_value"
                style="margin-right: 20px"
                :type="selectedValue === item ? 'primary' : 'info'"
                effect="plain"
                @click="checkAd(item)"
              >
                {{ item.label }}
              </el-tag>
            </div>
          </el-form-item>

          <el-form-item label="时间">
            <el-select
              v-model="create_month"
              placeholder="请选择"
              value-key="year_month"
              @change="create_monthChange"
            >
              <el-option
                v-for="item in timeOptions"
                :key="item.year_month"
                :label="item.year_month_text"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </div>
      </el-form>
    </div> -->

    <!-- 吸顶操作栏 -->
    <div class="sticky-header">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <!-- <div>
          <el-checkbox
            :indeterminate="isIndeterminate"
            :checked="isChecked"
            @change="handleToggleAll"
          >
            全选
          </el-checkbox>
          <el-tag
            style="margin-left: 5px"
            closable
            @close="handleToggleAll(false)"
          >
            已选{{ selectedItems.length }}
          </el-tag>
        </div> -->
        <!-- <el-button
          type="success"
          icon="el-icon-upload"
          :disabled="!selectedItems.length"
          @click="uploadMaterial"
        >上传</el-button> -->
        <el-button
          type="success"
          icon="el-icon-upload"
          :disabled="material_data.count == 0"
          @click="dowungirwr"
        >下载</el-button>
      </div>
    </div>

    <!-- 数据展示区域 -->
    <div style="display: flex;flex-wrap: wrap">
      <div
        v-for="(item, index) in material_data.list"
        :key="index"
        style="width: 438px;height: 412px;margin: 10px 8px;background-color: #FFFFFF;border-radius: 5px"
      >
        <div
          style="height: 78px;display: flex;justify-content: space-between;padding: 10px 15px;cursor: pointer"
          @click.stop="checkItem(item)"
        >
          <div style="display: flex;align-items: center;">
            <img
              v-if="item.product && item.product.product_icon"
              :src="item.product.product_icon"
              alt=""
              style="width: 44px; height: 44px; border-radius: 50%"
            >
            <div style="flex-direction: column;justify-content: center;align-items: center;margin-left: 10px">
              <div v-if="item.product && item.product.product_name" style="margin-bottom:7px;font-weight:600;font-size:16px">{{ item.product.product_name }}</div>
              <!-- <img
                v-for="(items, indexr) in item.media_details"
                :key="indexr"
                style="width: 21px;height: 21px;margin-right:10px"
                :src="items.media_logo"
                alt=""
              > -->
              <img v-if="item.media && item.media.logo_url" :src="item.media.logo_url" style="width: 21px;height: 21px;margin-right:10px" alt="">

            </div>
          </div>
          <div style="text-align: end">
            <!-- <el-checkbox
              v-if="item.upload_status!=1"
              :value="selectedItems.includes(item)"
              style="pointer-events: none"
              @click.native.stop
            />
            <el-tag
              v-else
              type="success"
            >已上传</el-tag> -->
            <div v-if="item.publisher && item.publisher.publisher_name" style="margin-top: 8px;font-size: 12px;max-width: 204px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ item.publisher.publisher_name }}</div>
          </div>
        </div>
        <div
          style="cursor: pointer;position: relative;"
          @click="itemInfo(item)"
        >
          <!-- <el-image
            :src="item.pic_list[0]"
            :alt="item.pic_list[0]"
            referrerpolicy="no-referrer"
            style="width: 438px;height: 180px"
            fit="cover"
          /> -->
          <el-image
            v-if="Array.isArray(item.pic_list) && item.pic_list.length > 0"
            :src="item.pic_list[0]"
            :alt="item.pic_list[0]"
            referrerpolicy="no-referrer"
            style="width: 438px; height: 180px"
            fit="cover"
          />
          <div v-else style="width: 438px; height: 180px" />
          <div style="position: absolute;bottom:0px;left:0px;display: flex;background-color: rgba(0, 0, 0, 0.3);padding: 10px 30px;width: 100%;justify-content: space-between;">
            <!-- <div>
              <img
                style="width:20px;height:20px;margin-right:5px"
                src="@/assets/images/adx/player.png"
                alt=""
                srcset=""
              >
              <span style="color:white">{{ item.play_num }}</span>
            </div> -->
            <div> <img
                    style="width:20px;height:20px;margin-right:5px"
                    src="@/assets/images/adx/like.png"
                    alt=""
                    srcset=""
                  >
              <span style="color:white">{{ item.like_num }}</span>
            </div>
            <!-- <div> <img
                    style="width:20px;height:20px;margin-right:5px"
                    src="@/assets/images/adx/comment.png"
                    alt=""
                    srcset=""
                  >
              <span style="color:white">{{ item.comment_num }}</span>
            </div>
            <div> <img
                    style="width:20px;height:20px;margin-right:5px"
                    src="@/assets/images/adx/forward.png"
                    alt=""
                    srcset=""
                  >
              <span style="color:white">{{ item.forward_num }}</span>
            </div> -->
          </div>
          <!-- <div style="position: absolute;top:6px;right:6px;background-color: rgba(0, 0, 0, 0.3);padding: 6px;border-radius:15px">02:13</div> -->
        </div>

        <!--        <div style="height: 154px">{{ item.description }}-->
        <!--&lt;!&ndash;          <video :src="item.video_list[0]" controls crossorigin="anonymous"></video>&ndash;&gt;-->
        <!--          <iframe :src="item.video_list[0]" frameborder="0" allowfullscreen></iframe>-->
        <!--        </div>-->
        <div
          style="height: 154px;padding: 20px 0;cursor: pointer"
          @click="itemInfo(item)"
        >
          <!-- <div style="height: 60px;font-size: 16px;line-height: 25px;padding: 0 20px">
            <div style="color: #1D2129;">{{ item.title }}</div>
            <div style="color: #86909C;width: 100%;height: 50%;overflow: hidden">{{ item.description }}</div>
          </div> -->
          <div style="height: 60px; font-size: 16px; line-height: 25px; padding: 0 20px;">
            <div
              v-if="item.playlet && item.playlet.playlet_name"
              style="color: #1D2129;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;"
              v-html="item.playlet.playlet_name"
            />
          </div>
          <div class="data-row">
            <div class="item">
              <div class="value">{{ item.exposure_num }}</div>
              <div class="label">曝光量</div>
            </div>
            <!-- <div class="divider" /> -->
            <!-- <div class="item">
              <div class="value">{{ item.appear_day }}</div>
              <div class="label">出现天数</div>
            </div> -->
            <div class="divider" />
            <div class="item">
              <div class="value">{{ item.material_days }}</div>
              <div class="label">投放天数</div>
            </div>
            <div class="divider" />
            <div class="item">
              <div class="value">{{ item.creative_num }}</div>
              <div class="label">计划数</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <pagination-right
      :total="material_data.count"
      :page-sizes="[10]"
      :current-page="query.page"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      :visible.sync="info_visible"
      :destroy-on-close="true"
      width="500px"
      title="素材详情"
    >
      <Info ref="matinfo" />
    </el-dialog>
  </div>
</template>

<script>
import { categoryList, /* materialList */ uploadMaterial } from '@/api/report/adx'
import PaginationRight from '@/components/PaginationRight/index.vue'
import Info from '@/views/adxkarka/components/info.vue'
import { kafkadownloadMaterial, kafkadetail } from '@/api/taobaoLink.js'
export default {
  components: { PaginationRight, Info },
  data() {
    return {
      showFilter: true,
      fieldToValueMap: {
        create_month: 'create_month',
        selectedValue: 'selectedValue',
        order_by: 'order_by',
        material_type: 'material_type'
      },
      query: {
        page: 1,
        page_size: 10
      },
      material_data: {
        total: 0,
        list: []
      },
      select_data: [],
      selectedValue: '',
      material_type: '',
      selectedItems: [],
      totalItems: [],
      options: [
        { label: '图片', value: '1' },
        { label: '视频', value: '2' }
      ],
      slot_option: [
        { label: '最多评论数', value: '1' },
        { label: '最大时长', value: '2' },
        { label: '最大曝光量', value: '3' },
        { label: '最多分享数', value: '4' },
        { label: '最多点赞数', value: '5' },
        { label: '最多播放量', value: '6' }
      ],
      options2: [
        { label: '信息流广告', ad_value: 'info_flow' },
        { label: '原生广告', ad_value: 'native' },
        { label: '非原生广告', ad_value: 'not_native' },
        { label: '达人广告', ad_value: 'talent' }
      ],
      create_month: null,
      slot_value: null,
      timeOptions: [],
      info_visible: false,
      task_id: null
    }
  },
  computed: {
    isChecked() {
      const list = this.material_data?.list || []
      return list.length > 0 && this.selectedItems.length === list.length
    },
    isIndeterminate() {
      const list = this.material_data?.list || []
      return this.selectedItems.length > 0 && this.selectedItems.length < list.length
    },
    filteredSelectData() {
      return this.select_data.filter(item => item.filed !== 'create_month')
    }
  },
  watch: {
    select_data: {
      handler(newVal) {
        this.materialList()
      },
      deep: true
    }
  },
  created() {
    console.log('query', this.$route.query.task_id)
    this.task_id = this.$route.query.task_id
    this.categoryList()
  },
  methods: {
    materialList() {
      // this.selectedItems = []
      // const params = {
      //   ...Object.fromEntries(this.select_data.map(item => [item.filed, item.value])),
      //   ...this.query
      // }
      kafkadetail({ task_id: this.task_id, ...this.query }).then(res => {
        this.material_data = res.data
      })
    },
    categoryList() {
      categoryList().then(res => {
        this.timeOptions = res.data
        this.create_month = res.data[0]
        this.create_monthChange(res.data[0])
      })
    },
    create_monthChange(val) {
      console.log(val)
      const existingIndex = this.select_data.findIndex(item => item.filed === 'create_month')
      const newItem = {
        filed: 'create_month',
        text: val.year_month_text,
        value: val.year_month
      }
      if (existingIndex !== -1) {
        this.select_data.splice(existingIndex, 1, newItem)
      } else {
        this.select_data.push(newItem)
      }
    },
    checkAd(val) {
      this.selectedValue = val
      const existingIndex = this.select_data.findIndex(item => item.filed === 'selectedValue')
      const newItem = {
        filed: 'selectedValue',
        text: val.label,
        value: val.ad_value
      }
      if (existingIndex !== -1) {
        this.$set(this.select_data, existingIndex, newItem)
      } else {
        this.select_data.push(newItem)
      }
    },
    checkSlot(val) {
      this.slot_value = val
      const existingIndex = this.select_data.findIndex(item => item.filed === 'order_by')
      const newItem = {
        filed: 'order_by',
        text: val.label,
        value: val.value
      }
      if (existingIndex !== -1) {
        this.$set(this.select_data, existingIndex, newItem)
      } else {
        this.select_data.push(newItem)
      }
    },
    checkMaterialType(val) {
      this.material_type = val
      const existingIndex = this.select_data.findIndex(item => item.filed === 'material_type')
      const newItem = {
        filed: 'material_type',
        text: val.label,
        value: val.value
      }
      if (existingIndex !== -1) {
        this.$set(this.select_data, existingIndex, newItem)
      } else {
        this.select_data.push(newItem)
      }
    },
    handleToggleAll(val) {
      if (val) {
        this.selectedItems = this.generateAllItems()
      } else {
        this.selectedItems = []
      }
    },
    selectDataDel(tag) {
      this.select_data = this.select_data.filter(item => item.filed !== tag.filed)
      const boundVar = this.fieldToValueMap[tag.filed]
      if (boundVar) this[boundVar] = null
    },
    fetchPageSize(data) {
      this.query.page = 1
      this.query.page_size = data
      this.materialList()
    },
    fetchCurrentPage(data) {
      this.query.page = data
      this.materialList()
    },
    generateAllItems() {
      // eslint-disable-next-line eqeqeq
      return this.material_data.list.filter(item => item.upload_status != 1)
    },
    checkItem(item) {
      console.log(item)
      // eslint-disable-next-line eqeqeq
      if (item.status === 1 || item.upload_status == 1) return // status为1的项目不处理

      const index = this.selectedItems.indexOf(item)
      if (index === -1) {
        this.selectedItems.push(item)
      } else {
        this.selectedItems.splice(index, 1)
      }
    },
    uploadMaterial() {
      // this.$prompt('请输入标签id', '提交上传', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   inputValidator: value => {
      //     if (!value || value.trim() === '') {
      //       return 'b_id不能为空'
      //     }
      //     return true // 验证通过
      //   },
      //   inputErrorMessage: '输入不能为空'
      // }).then(({ value }) => {
      //   const material_nos = this.selectedItems.map(item => item.material_no)
      //   console.log(material_nos)
      //   uploadMaterial({ material_nos: material_nos, tag_id: value }).then(res => {
      //     console.log(res)
      //     // eslint-disable-next-line eqeqeq
      //     if (res.code == 0) {
      //       this.$message.success('创建任务成功，请等待上传成功')
      //       this.selectedItems = []
      //     }
      //   })
      // })
      const material_nos = this.selectedItems.map(item => item.material_no)
      console.log(material_nos)
      uploadMaterial({ material_nos: material_nos }).then(res => {
        console.log(res)
        // eslint-disable-next-line eqeqeq
        if (res.code == 0) {
          this.$message.success('创建任务成功，请等待上传成功')
          this.selectedItems = []
          this.materialList()
        }
      })
    },
    itemInfo(val) {
      console.log(val)
      this.info_visible = true
      this.$nextTick(() => {
        this.$refs.matinfo.send(val)
      })
    },
    materialListr() {
      this.query.page = 1
      this.materialList()
    },
    dowungirwr() {
      kafkadownloadMaterial({
        task_id: this.task_id
      }).then((res) => {
        this.$message.success('下载成功')
        // window.open(res.data.url)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.search-container {
  display: flex;
  width: 300px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
}

.search-input {
  flex: 1;
  border: none;
  padding: 8px 12px;
  font-size: 14px;
  outline: none;
}

.search-button {
  background-color: #1890ff;
  color: white;
  border: none;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.search-button:hover {
  background-color: #46a6ff;
}

.sticky-header {
  background-color: #F1F2F5;
  margin-top: 10px;
  padding: 20px;
  position: sticky;
  top: 85px;
  z-index: 999;
}

.data-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 8px; /* 控制上下间距，不需要左右 padding */
}

.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 60px; /* 你可以根据字体大小微调 */
  flex-shrink: 0;
}

.value {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.label {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}

.divider {
  width: 1px;
  height: 30px;
  background-color: #eee;
  flex-shrink: 0;
}
</style>
